/*
 *  TODO:
 *   - give modal the ability to have a sub-view / views
 *   - make base modal a form
 *  Current uses have it overridable or have content that doesn't require interaction.
 *  This is extending the existing modal dialog directly.
 * */

var Modal = require('../../common/modal/modal'),
    _ = require('underscore');

require('./style.less');


module.exports = Modal.extend({
    baseModalDefaults: {
        title: 'Add Page'
    },
    contentTemplate: require('./template.hbs'),
    initialize: function(options) {

        this.settings = _.extend( {}, {
            content: this.contentTemplate()
        }, options );

        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );

        return this;
    },

    ui: _.extend( {}, Modal.prototype.ui, {
        form:               '#add-pg-form',
        fileInput:          '#file-upload-input',
        uploadList:         '#file-upload-list', // This may wind up a seperate view
        uploadLbl:          '#upload-label',
        insertLastRadio:    '#insert-last',
        insertFirstRadio:   '#insert-first',
        numFiles:           '#n-files-selected'
    }),
    onShow: function() {
        Modal.prototype.onShow.apply(this, arguments);
        setTimeout( _.bind( function() {
            this.ui.fileInput.focus();
        }, this), 1);
    },
    events: _.extend( {} , Modal.prototype.events, {
        'submit @ui.form':          'onFormSubmit',
        'change @ui.fileInput':     'onFileChange'
    }),
    onFileChange: function() {

        this.ui.uploadList
            .html('')
            .removeClass('showOutline');

        this.ui.numFiles.html('');

        var files = this.ui.fileInput[0].files, //('FileList' of 'File' objects) -- name, size, type
            nFiles = files.length;

        if (nFiles < 1)
            return;

        this.ui.numFiles.html( '(' + nFiles + ' selected)' );

        _.each(files, function (f) {
                this.ui.uploadList.append('<li>' + f.name + '</li>');
            }, this);

        if ( this.ui.uploadList[0].offsetHeight  < this.ui.uploadList[0].scrollHeight )
            this.ui.uploadList.addClass('showOutline');

    },
    ok: function() {
        var fileList = this.ui.fileInput[0].files;
        if (fileList.length < 1) {
            this.destroy();
            return;
        }

        this.settings.okCB( fileList, this._getInsertPgNumber() );
        this.destroy();
    },
    _getInsertPgNumber: function() {
        if ( this.ui.insertFirstRadio.is(':checked') ) {
            return 1; // the first page
        } else if ( this.ui.insertLastRadio.is(':checked') ) {
            // default
            return null;
        }
        // may later put select box with range ...
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/addPage/view.js
 ** module id = 139
 ** module chunks = 0
 **/